import {load} from '@shopify/theme-sections';
import '../sections/product';
import '../sections/instagram-feed';
import debounce from 'lodash/debounce';

document.addEventListener('DOMContentLoaded', () => {
  load('*');
  initFeaturedBar();
  initComparatorTable();
});

function initFeaturedBar() {
  const headerSection = document.querySelector('.site-header');
  const featuredBar = document.querySelector('.product-featured__bar');

  if (featuredBar === null) return;

  const featuredBarAddToCart = featuredBar.querySelector('.product-featured__bar-section--add-to-cart');
  const productForm = document.querySelector('#ProductForm');

  /**
   * The value of top is set in CSS to best correspond to the height of the header and announcement bar.
   * If however content has caused it to be larger or smaller, it should adjust the placement
   * of the featuredBar on page load.
   */
  featuredBar.style.top = `${headerSection.offsetHeight - 1}px`;
  window.addEventListener(
    'resize',
    debounce(() => {
      featuredBar.style.top = `${headerSection.offsetHeight - 1}px`;
    }, 250)
  );

  /**
   * Show/hide the add to cart button in the featured bar depending on whether
   * the main product form is on screen or not.
   */
  const productFormObserver = new IntersectionObserver(entries => {
    if (entries[0].intersectionRatio <= 0 && entries[0].boundingClientRect.top < 0) {
      featuredBarAddToCart.classList.add('is-visible');
    } else {
      featuredBarAddToCart.classList.remove('is-visible');
    }
  });
  productFormObserver.observe(productForm);
}

function initComparatorTable() {
  // Sync horizontal scroll for table header and table on mobile only
  const mobileQuery = window.matchMedia(`(max-width: ${theme.breakpoints.large - 1}px)`);
  const comparatorTableHeader = document.querySelector('.comparator__table-header');
  const comparatorTable = document.querySelector('.comparator__table-wrapper');

  if (!comparatorTableHeader || !comparatorTable) return;

  const comparatorProduct = document.querySelector('.comparator__product');
  const comparatorDots = document.querySelectorAll('[data-comparator-dot]');

  if (mobileQuery.matches) {
    initScrollSync();
    initScrollDots();
  }

  mobileQuery.addEventListener('change', event => {
    if (event.matches) {
      initScrollSync();
      initScrollDots();
    }
  });

  function initScrollSync() {
    let isScrollingTable = false;
    let scrollingTableTimer;
    let isScrollingHeader = false;
    let scrollingHeaderTimer;

    comparatorTable.addEventListener('scroll', () => {
      if (isScrollingHeader) return;

      isScrollingTable = true;
      comparatorTableHeader.scrollLeft = comparatorTable.scrollLeft;
      if (comparatorDots.length > 0) {
        const activeDotIndex = comparatorTableHeader.scrollLeft > comparatorProduct.offsetWidth / 2 ? 1 : 0;
        comparatorDots.forEach((comparatorDot, index) =>
          activeDotIndex === index
            ? comparatorDot.classList.add('is-selected')
            : comparatorDot.classList.remove('is-selected')
        );
      }

      clearTimeout(scrollingTableTimer);
      scrollingTableTimer = setTimeout(() => {
        isScrollingTable = false;
      }, 100);
    });

    comparatorTableHeader.addEventListener('scroll', () => {
      if (isScrollingTable) return;

      isScrollingHeader = true;
      comparatorTable.scrollLeft = comparatorTableHeader.scrollLeft;
      if (comparatorDots.length > 0) {
        const activeDotIndex = comparatorTable.scrollLeft > comparatorProduct.offsetWidth / 2 ? 1 : 0;
        comparatorDots.forEach((comparatorDot, index) =>
          activeDotIndex === index
            ? comparatorDot.classList.add('is-selected')
            : comparatorDot.classList.remove('is-selected')
        );
      }

      clearTimeout(scrollingHeaderTimer);
      scrollingHeaderTimer = setTimeout(() => {
        isScrollingHeader = false;
      }, 100);
    });
  }

  function initScrollDots() {
    comparatorDots.forEach(comparatorDot => comparatorDot.addEventListener('click', scrollComparator));
  }

  function scrollComparator(event) {
    const index = event.currentTarget.dataset.comparatorDot;
    comparatorTableHeader.scrollTo({
      top: 0,
      left: index * comparatorProduct.offsetWidth,
      behavior: 'smooth',
    });
  }
}
